(function(){

  function initializeFinder(root) {
    var configNode = root.closest('[id^="shopify-section-"]').querySelector('[data-otr-finder-config]');
    if (!configNode) return;
    var config = JSON.parse(configNode.textContent);
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var stage = root.querySelector('[data-stage]');
    var dots = root.querySelectorAll('[data-dot]');
    var answers = {};
    var travelImg = config.travelImg;
    var titanImg = config.titanImg;
    var travelAlt = config.travelAlt;
    var titanAlt = config.titanAlt;
    var copy = config.copy;

    function esc(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    var steps = {
      use: {
        q: copy.q1 || 'Where will you use it most?',
        options: [
          ['rv', copy.q1Rv || 'I live out of an RV'],
          ['truck', copy.q1Truck || 'The truck is my office'],
          ['home', copy.q1Home || 'I need it at a home or cabin'],
          ['business', copy.q1Business || 'I run a business on the move'],
          ['everywhere', copy.q1Everywhere || "I can't be tied down"]
        ]
      },
      devices: {
        q: copy.q2 || 'How many devices need to be online?',
        options: [
          ['10', copy.q2Few || 'A few devices, up to 10'],
          ['16', copy.q2Full || 'A full setup, 11 to 16'],
          ['more', copy.q2More || 'More gear than 16 devices']
        ]
      }
    };

    function priorityOptions() {
      var opts = [
        ['cost', copy.q3Cost || 'Keep the monthly cost down'],
        ['coverage', copy.q3Coverage || 'Coverage that keeps up with me'],
        ['performance', copy.q3Performance || 'Speed when it matters']
      ];
      if (answers.devices !== 'more') opts.push(['portable', copy.q3Portable || 'Toss it in a bag']);
      return opts;
    }

    function recommend() {
      if (answers.devices === 'more') return 'travel';
      if (answers.priority === 'portable') return 'titan';
      if (answers.priority === 'cost') return 'titan';
      if (answers.priority === 'coverage') return 'titan';
      return 'travel';
    }

    function why(pick) {
      if (pick === 'titan') {
        if (answers.priority === 'portable') return copy.whyTitanPortable || 'A battery powered 5G hotspot you can carry. Built for up to 16 devices.';
        if (answers.priority === 'cost') return copy.whyTitanCost || 'The lower start price, with the hotspot and first month included.';
        if (answers.priority === 'coverage') return copy.whyTitanCoverage || 'A 5G hotspot that can use more than one carrier, for up to 16 devices.';
        return copy.whyTitanDefault || 'A simple 5G hotspot for everyday use on the road.';
      }
      if (answers.devices === 'more') return copy.whyTravelMore || 'A 4G and 5G router for bigger setups, wired gear, and up to 64 devices.';
      if (answers.use === 'home' || answers.use === 'business') return copy.whyTravelFixed || 'A 4G and 5G router with ethernet and dual band WiFi for a fixed or work setup.';
      return copy.whyTravelDefault || 'A 4G and 5G router when you want stronger WiFi and room for more gear.';
    }

    function setDots(n) {
      dots.forEach(function (dot) {
        dot.classList.toggle('is-on', Number(dot.dataset.dot) <= n);
      });
    }

    function optionsHtml(list, odd) {
      return '<div class="otr-finder__options' + (odd ? ' is-odd' : '') + '">' + list.map(function (opt) {
        return '<button type="button" class="otr-finder__opt" data-value="' + esc(opt[0]) + '">' + esc(opt[1]) + '</button>';
      }).join('') + '</div>';
    }

    function paintQuestion(key, list, stepNum) {
      setDots(stepNum);
      var odd = list.length % 2 === 1;
      stage.innerHTML = '<h3 class="otr-finder__q">' + esc(steps[key].q) + '</h3>' + optionsHtml(list, odd) +
        (stepNum > 1 ? '<button type="button" class="otr-finder__back" data-back>' + esc(copy.back || 'Back') + '</button>' : '');
      stage.dataset.step = key;
    }

    function paintPriority() {
      setDots(3);
      var list = priorityOptions();
      stage.innerHTML = '<h3 class="otr-finder__q">' + esc(copy.q3 || 'What matters most?') + '</h3>' + optionsHtml(list, list.length % 2 === 1) +
        '<button type="button" class="otr-finder__back" data-back>' + esc(copy.back || 'Back') + '</button>';
      stage.dataset.step = 'priority';
    }

    function paintResult() {
      var pick = recommend();
      var isTitan = pick === 'titan';
      var sceneList = isTitan ? (config.hotspotScenes || []) : (config.travelScenes || []);
      var sceneKey = isTitan ? 'otrAbScene:hotspot' : 'otrAbScene:travel';
      var sceneIndex = 0;
      if (sceneList.length) {
        var storedScene = null;
        try { storedScene = window.localStorage.getItem(sceneKey); } catch (e) {}
        sceneIndex = storedScene == null || storedScene === '' ? Math.floor(Math.random() * sceneList.length) : Number(storedScene);
        if (!(sceneIndex >= 0 && sceneIndex < sceneList.length)) sceneIndex = 0;
        try { window.localStorage.setItem(sceneKey, String(sceneIndex)); } catch (e) {}
      }
      var img = sceneList.length ? sceneList[sceneIndex] : (isTitan ? titanImg : travelImg);
      var alt = isTitan ? titanAlt : travelAlt;
      var name = isTitan ? (copy.titanName || 'Titan 5G Hotspot') : (copy.travelName || 'Travel Plan');
      var today = isTitan ? copy.titanToday : copy.travelToday;
      var month = isTitan ? copy.titanMonth : copy.travelMonth;
      var url = isTitan ? copy.titanUrl : copy.travelUrl;
      setDots(3);
      stage.innerHTML =
        '<div class="otr-finder__result">' +
          (img ? '<img class="otr-finder__photo" alt="' + esc(alt) + '" src="' + esc(img) + '" width="160" height="160" loading="lazy" decoding="async">' : '') +
          '<div><span class="otr-finder__badge">' + esc(copy.badge || 'OTR FLEX PAY') + '</span>' +
          '<p class="otr-finder__kicker">' + esc(copy.resultKicker) + '</p>' +
          '<h3 class="otr-finder__name">' + esc(name) + '</h3>' +
          '<p class="otr-finder__why">' + esc(why(pick)) + '</p>' +
          '<p class="otr-finder__price">' + esc(today) + '</p>' +
          '<p class="otr-finder__after">' + esc(month) + '</p>' +
          '<a class="otr-finder__buy" href="' + esc(url) + '">' + esc(copy.buy) + '</a>' +
          '<button type="button" class="otr-finder__restart" data-restart>' + esc(copy.again) + '</button></div></div>';
      stage.dataset.step = 'result';
    }

    function go(step) {
      if (step === 'use') paintQuestion('use', steps.use.options, 1);
      else if (step === 'devices') paintQuestion('devices', steps.devices.options, 2);
      else if (step === 'priority') paintPriority();
      else paintResult();
    }

    stage.addEventListener('click', function (event) {
      var opt = event.target.closest('[data-value]');
      var back = event.target.closest('[data-back]');
      var restart = event.target.closest('[data-restart]');
      if (restart) { answers = {}; go('use'); return; }
      if (back) {
        if (stage.dataset.step === 'priority') go('devices');
        else if (stage.dataset.step === 'devices') go('use');
        else if (stage.dataset.step === 'result') go('priority');
        return;
      }
      if (!opt) return;
      var value = opt.getAttribute('data-value');
      if (stage.dataset.step === 'use') { answers.use = value; go('devices'); }
      else if (stage.dataset.step === 'devices') {
        answers.devices = value;
        if (value === 'more') delete answers.priority;
        go('priority');
      } else if (stage.dataset.step === 'priority') {
        answers.priority = value;
        paintResult();
      }
    });

    go('use');
  }
function initializeFinders(scope) { scope.querySelectorAll("[data-otr-finder]").forEach(initializeFinder); }
initializeFinders(document);
document.addEventListener("shopify:section:load", function(event) { initializeFinders(event.target); });
})();
